import { Typography } from '@material-ui/core';
import React, { FC } from 'react';
import genericCarNameStyles from './genericCarNameStyles';

export interface IGenericCarNameProps {
  modelName: string;
  variantName: string;
  className?: string;
  testId?: string;
}

const GenericCarName: FC<IGenericCarNameProps> = ({ modelName, variantName, className, testId }) => {
  const styles = genericCarNameStyles();

  return (
    <Typography className={className} data-test={testId} align={'center'}>
      <Typography component="span" variant="h4" className={styles.modelName}>
        {modelName}
      </Typography>
      <Typography component="span" variant="h4" className={styles.variantName}>
        {variantName}
      </Typography>
    </Typography>
  );
};

export default GenericCarName;
